import Base from "./Base";

class Assistant extends Base {
    static addLog(body) {
        return this.sendRequest("/assistant/add-log", "POST", {}, body);
    }

    static getChat(body) {
        return this.sendRequest("/assistant/get-chat", "POST", {}, body);
    }

    static getChats(body) {
        return this.sendRequest("/assistant/get-chats", "POST", {}, body);
    }

    static updateResponses(body) {
        return this.sendRequest("/assistant/update-responses", "POST", {}, body);
    }

    static getChatsAccessToken(body = {}) {
        return this.sendRequest("/assistant/chats-token", "POST", {}, body);
    }

    static getAllChats(body) {
        return this.sendRequest("/assistant/get-all-chats", "POST", {}, body);
    }

    static chats(body) {
        return this.sendRequest("/chats/get-chats", "POST", {}, body);
    }
    
    static notifyAdmin(body) {
        return this.sendRequest("/assistant/notify-admin", "POST", {}, body);
    }
}

export default Assistant;